import { useState, useEffect, useMemo } from 'react';
import { getData, putData, postData } from "../../../../../services/library";
import { logEventos } from "../../../../../services/services";
import { Dialog, DialogContent, DialogActions, Box, Grid, IconButton, Typography, Button, Snackbar, Alert, } from '@mui/material';
import MaterialReactTable from 'material-react-table';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import { UrlApi } from '../../../../../services/apirest';
import Zoom from '@mui/material/Zoom';
import { MRT_Localization_ES } from 'material-react-table/locales/es';
import { formatoImporte } from '../../../formatoImporte';

export default function ListaMaterialesPanel(props) {
  const [datosReq, setDatosReq] = useState(props.datos);
  const [listaMateriales, setlistaMateriales] = useState([]);
  const [disBtn, setdisBtn] = useState(true);
  const [hasPendingItems, setHasPendingItems] = useState(false);
  const [snackbar, setSnackbar] = useState({
    open: false,
    message: '',
    severity: 'info',
  });

  const [notificacion, setNotificacion] = useState({
    open: false,
    mensaje: "",
    severity: "",
    color: "",
  });

  const obtenerListaMaterial = () => {
    // console.log("vuelvo a llamar");

    getData(
      `/lista_materiales/req/${datosReq.uuid_requerimiento}`,
      (data) => {
        // console.log("data", data);
        setlistaMateriales(data);

        // Calcular pendientes al cargar
        const { hasPendientes } = checkPendientes(data);
        setHasPendingItems(hasPendientes);
        // console.log("haspendientes", hasPendientes);
      }
    ).catch((error) => {
      console.error("Error al obtener lista de materiales:", error);
      setSnackbar({
        open: true,
        message: "Error al cargar los materiales",
        severity: "error",
      });
    });
  };

  const checkPendientes = (lista) => {
    const pendientes = lista
      .map((item) => {
        const cantidad = parseFloat(item.cantidad) || 0;
        const cantidadActualizada = parseFloat(item.cantidad_actualizada) || 0;
        const cantidadFaltante = cantidad - cantidadActualizada;

        const sinOrden = !item.uuid_ordencompra || item.uuid_ordencompra === "";

        if (cantidadFaltante > 0 || sinOrden) {
          return {
            ...item,
            cantidad,
            cantidad_actualizada: cantidadActualizada,
            cantidadFaltante,
          };
        }
        return null;
      })
      .filter((item) => item !== null);

    return {
      hasPendientes: pendientes.length > 0,
      pendientes,
    };
  };

  useEffect(() => {
    if (props.open && datosReq.uuid_requerimiento) {
      obtenerListaMaterial();
    }
  }, [props.open, datosReq.uuid_requerimiento, props.uuid]);

  const handleClose = () => {
    props.open(false); // Ajustado para usar setOpen
    props.actualizar();
    props.obtenerReq();
  };

  const handleConfirmAndClose = async (e) => {
  try {
    if (!props.uuid) {
      setSnackbar({
        open: true,
        message: "UUID de orden de compra no proporcionado",
        severity: "error",
      });
      return;
    }

    // Revisar pendientes con la lista actual
    const { hasPendientes, pendientes } = checkPendientes(listaMateriales);
    const nuevoEstado = hasPendientes ? 313 : 58;
    // console.log("nuevoEstado", nuevoEstado);

    // Si hay pendientes, crear items
    if (hasPendientes && pendientes.length > 0) {
      const datosLista = pendientes.map((item) => ({
        cantidad: item.cantidadFaltante,
        usuario: localStorage.getItem("user"),
        uuid_requerimiento: datosReq.uuid_requerimiento,
        uuid_ordencompra: null,
        precio_unitario: null,
        subtotal: null,
        bonificacion_pesos: null,
        cantidad_actualizada: null,
        id_articulo: item.id_articulo || null,
        bonificacion_porcentaje: null,
        material: item.material || "Material sin nombre",
        id_unidad_medida: item.id_unidad_medida || null,
      }));

      // console.log("Creando pendientes:", datosLista);

      const resp = await fetch(`${UrlApi}/lista_materiales`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ datosLista }),
      });

      if (!resp.ok) throw new Error("Error al crear ítems pendientes");

      logEventos(
        "Carga de lista materiales",
        "AddOrdenCompra",
        "Crear nuevo item en lista_materiales por requerimientos incompletos",
        localStorage.getItem("user")
      );
    }

    // Actualizar requerimiento
    const respReq = await fetch(
      `${UrlApi}/requerimientos_materiales/${datosReq.idrequerimiento}`,
      {
        method: "PUT",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          estado: nuevoEstado,
          uuid_ordencompra: props.uuid,
        }),
      }
    );

    if (!respReq.ok) throw new Error("Error al actualizar requerimiento");

    setSnackbar({
      open: true,
      message: `Requerimiento actualizado a estado ${
        nuevoEstado === 58 ? "Completado" : "Parcial"
      } y vinculado a la orden.`,
      severity: "success",
    });

    await logEventos(
      "Cambiar estado de requerimiento",
      "Requerimientos materiales",
      "Requerimientos materiales",
      localStorage.getItem("user")
    );

    // Vincular archivos
    const respUpload = await fetch(
      `${UrlApi}/uploadfiles/${datosReq.uuid_requerimiento}`,
      {
        method: "PUT",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ uuid_ordencompra: props.uuid }),
      }
    );

    if (!respUpload.ok) throw new Error("Error al vincular archivos");

    handleClose();
  } catch (error) {
    console.error("Error al confirmar y cerrar:", error);
    setSnackbar({
      open: true,
      message:
        "Error al actualizar el estado del requerimiento o crear ítems pendientes",
      severity: "error",
    });
  }
};

  //actualizar cada item de la lista.
 const guardarTodo = async ({ exitEditingMode, row, values }) => {
   const parseNumber = (val) =>
      val !== null && val !== undefined && val !== ''
        ? parseFloat(String(val).replace(',', '.'))
        : null;

  try {
    let material = row.original.material ? row.original.material : row.original.nombre;
    const cantidadActualizada = parseNumber(values.cantidad_actualizada) || 0;
    const precioUnitario = parseNumber(values.precio_unitario) || 0;
    const bonifPesos = values.bonificacion_pesos ? parseNumber(values.bonificacion_pesos) : null;
    const bonifPorcentaje = values.bonificacion_porcentaje ? parseNumber(values.bonificacion_porcentaje) : null;

    let subtotal;
    if (bonifPesos !== null && !isNaN(bonifPesos)) {
      subtotal = cantidadActualizada * precioUnitario - bonifPesos;
    } else if (bonifPorcentaje !== null && !isNaN(bonifPorcentaje)) {
      subtotal = cantidadActualizada * precioUnitario * (1 - bonifPorcentaje / 100);
    } else {
      subtotal = cantidadActualizada * precioUnitario;
    }

    const updatedItem = {
      ...row.original,
      material,
      precio_unitario: precioUnitario,
      cantidad_actualizada: cantidadActualizada,
      bonificacion_pesos: bonifPesos,
      bonificacion_porcentaje: bonifPorcentaje,
      subtotal,
      uuid_ordencompra: props.uuid,
    };

    const response = await fetch(`${UrlApi}/lista_materiales/lista/${row.original.idlista}`, {
      method: "PUT",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({
        material,
        precio_unitario: precioUnitario,
        cantidad_actualizada: cantidadActualizada,
        bonificacion_pesos: bonifPesos,
        bonificacion_porcentaje: bonifPorcentaje,
        uuid_ordencompra: props.uuid,
        usuario: localStorage.getItem("user"),
        subtotal,
      }),
    });

    if (!response.ok) throw new Error(`Error al actualizar el ítem: ${response.statusText}`);

    // Actualizar lista local
    let updatedListaMateriales;
    setlistaMateriales((prev) => {
      updatedListaMateriales = prev.map((item) =>
        item.idlista === row.original.idlista ? updatedItem : item
      );
      return updatedListaMateriales;
    });

    // Calcular pendientes con la lista actualizada
    const { hasPendientes } = checkPendientes(updatedListaMateriales);
    setHasPendingItems(hasPendientes);
    // console.log("haspendientes", hasPendientes);

    await logEventos(
      "Actualizar lista materiales para agregar a orden compra desde otro requerimiento",
      "Lista Materiales Panel",
      "Generar orden compra",
      localStorage.getItem("user")
    );

    setdisBtn(false);
    exitEditingMode();
  } catch (error) {
    console.error("Error al guardar el ítem:", error);
    setSnackbar({
      open: true,
      message: "Error al actualizar el ítem",
      severity: "error",
    });
  }
};

  const columns = useMemo(
    () => [
      {
        header: 'Requerido',
        accessorKey: 'cantidad',
        enableEditing: false,
        size: 80,
      },
      {
        header: 'A Comprar',
        accessorKey: 'cantidad_actualizada',
        required: false,
        type: 'numeric',
        size: 100,

      },
      {
        header: 'Artículo',
        accessorFn: (lm) => lm.nombre ?? lm.material,
        enableEditing: false,
        size: 200,
      },
      {
        header: 'Unidad',
        accessorFn: (lm) => lm.descripcion ?? lm.descripcion_material,
        enableEditing: false,
        size: 80,
      },
      // {
      //   header: '$ Unitario',
      //   accessorKey: 'precio_unitario',
      //   type: 'number',
      //   size: 100,
      //   required: true,
      // },
       {
        header: '$ Unitario',
        accessorKey: 'precio_unitario',
        size: 40,
        muiEditTextFieldProps: ({ cell }) => ({
          type: 'text',
          inputMode: 'decimal',
          // al abrir la edición, reemplazamos el punto por coma
          defaultValue: String(cell.getValue() ?? '').replace('.', ','),
          onChange: (e) => {
            // solo números, coma o punto
            e.target.value = e.target.value.replace(/[^0-9.,]/g, '');
          },
        }),
        //aca mostramos como se muestra 
        Cell: ({ cell }) => {
          const value = cell.getValue();
          if (value == null || value === '') return '';

          //y aca formateamos jajajajaja
          return new Intl.NumberFormat('es-AR', {
            minimumFractionDigits: 2,
            maximumFractionDigits: 2,
          }).format(Number(value));
        },
      },
      {
        header: 'Bonif %',
        accessorKey: 'bonificacion_porcentaje',
        type: 'number',
        required: false,
        size: 80,
      },
      {
        header: 'Bonif $',
        accessorKey: 'bonificacion_pesos',
        type: 'number',
        required: false,
        size: 80,
        Cell: ({ cell }) => formatoImporte(cell.getValue()),
      },
      {
        header: 'Subtotal',
        accessorKey: 'subtotal',
        enableEditing: false,
        type: 'numeric',
        size: 40,
        Cell: ({ cell }) => {
          const value = cell.getValue();
          if (value == null || value === '') return '';
          // 👇 formatea como 1.234,56
          return new Intl.NumberFormat('es-AR', {
            minimumFractionDigits: 2,
            maximumFractionDigits: 2,
          }).format(value);
        },
      },
      //   header: 'Subtotal',
      //   accessorKey: 'subtotal',
      //   type: 'number',
      //   enableEditing: false,
      //   size: 100,
      // },
    ],
    [props.datos.uuid_requerimiento_original]
  );

  const tableHeadCellProps = {
    align: 'center',
    sx: {
      fontSize: 14,
      color: 'black',
      fontWeight: 'normal',
      backgroundColor: '#D4E6F1',
      borderColor: '#FDFEFE',
    },
  };

  const initialState = {
    density: 'compact',
    pagination: { pageIndex: 0, pageSize: 15 },
  };

  return (
    <Dialog
      open={props.open}
      onClose={handleClose}
      maxWidth="xl"
      fullWidth
      TransitionComponent={Zoom}
    >
      <DialogContent sx={{ p: 3 }}>
        <Box sx={{ bgcolor: 'background.default', borderRadius: 2, p: 2 }}>
          <Grid container alignItems="center">
            <Grid item xs={2}>
              <IconButton onClick={handleClose}>
                <ArrowBackIcon sx={{ color: 'text.primary' }} />
              </IconButton>
            </Grid>
            <Grid item xs={10}>
              <Typography variant="h6" align="center">
                Ítems del Requerimiento #{datosReq.idrequerimiento}
              </Typography>
            </Grid>
          </Grid>
          {listaMateriales && (
            <MaterialReactTable
              columns={columns}
              data={listaMateriales}
              initialState={initialState}
              enableColumnResizing
              enableExpandAll={false}
              enableToolbarInternalActions={false}
              muiTableHeadCellProps={tableHeadCellProps}
              enableColumnActions={false}
              enableDensityToggle={false}
              enableColumnDragging={false}
              muiTableBodyCellProps={({ row }) => ({
                align: 'center',
                sx: {
                  backgroundColor: '#fff',
                  color: 'black',
                  borderColor: 'black',
                },
              })}
              layoutMode="grid"
              editingMode="row"
              enableEditing
              enableHiding={false}
              positionActionsColumn="last"
              renderTopToolbar={false}
              positionExpandColumn="first"
              enableStickyFooter
              enableGlobalFilter={false}
              onEditingRowSave={guardarTodo}
              localization={MRT_Localization_ES}
            />
          )}
        </Box>
      </DialogContent>
      <DialogActions>
        <Grid container direction="row" justifyContent="space-between" alignItems="center">
          <Button onClick={handleClose} variant="outlined" color="error">
            Cancelar
          </Button>
          <Button
            disabled={disBtn}
            onClick={handleConfirmAndClose} variant="contained" color="success">
            Confirmar y Cerrar
          </Button>
        </Grid>
      </DialogActions>
      <Snackbar
        open={snackbar.open}
        autoHideDuration={6000}
        onClose={() => setSnackbar({ ...snackbar, open: false })}
        anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
      >
        <Alert
          onClose={() => setSnackbar({ ...snackbar, open: false })}
          severity={snackbar.severity}
          sx={{ width: '100%' }}
        >
          {snackbar.message}
        </Alert>
      </Snackbar>
    </Dialog>
  );
}
//----- Component --------------------------------------------------------/
// Developer : Candela Grosso
// Creation Date :18/09/2025
// Version : 1
// Description : Componente para Visualizar la lista de materiales de un requerimiento para pasarlo a una orden de compra
//
//========================================================================/


// para pesar mas adelante: 
//  hasta que no apriete confirmar y cerrar el item  no deberia irse del requerimiento.. entonces  si le das guardar al item que guarde todo menos la relacion de uuid del requerimiento padre digamos, es por si se arrepiente
